export const PHONE_DISPLAY = "+91 70215 88860";
export const PHONE_TEL = "tel:+917021588860";
export const EMAIL = "keshavpadwal@gmail.com";
export const WHATSAPP_URL = "https://wa.me/917021588860";
export const waLink = (message) =>
  `https://wa.me/917021588860?text=${encodeURIComponent(message)}`;
